// Quest reset utility for development/admin purposes

export const getAllQuests = () => {
  return [
    'eating-out',
    'savings',
    'emergency-fund',
    'weekly-check-in',
    'financial-guru',
    'track-spending',
    'top-spending-category',
    'yearly-income',
    'spending-guesstimate'
  ];
};

export const resetAllQuests = () => {
  const quests = getAllQuests();
  const resetKeys: string[] = [];

  // Remove all quest-related localStorage keys
  quests.forEach(questId => {
    const questKey = `quest_${questId}`;
    if (localStorage.getItem(questKey)) {
      localStorage.removeItem(questKey);
      resetKeys.push(questKey);
    }
  });

  // Also remove quest-related data
  const questRelatedKeys = [
    'yearly_income',
    'yearly_income_budget',
    'monthly_spending_guess',
    'emergency_fund_goal_amount'
  ];

  questRelatedKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
      resetKeys.push(key);
    }
  });

  console.log('Reset quest data. Removed keys:', resetKeys);
  return resetKeys;
};

export const getQuestStatus = () => {
  const quests = getAllQuests();
  const status: Record<string, any> = {};

  quests.forEach(questId => {
    const questKey = `quest_${questId}`;
    const questData = localStorage.getItem(questKey);

    if (questData) {
      try {
        status[questId] = JSON.parse(questData);
      } catch (error) {
        status[questId] = { error: 'Invalid JSON data' };
      }
    } else {
      status[questId] = null; // Not started
    }
  });

  return status;
};

export const resetSpecificQuest = (questId: string) => {
  const questKey = `quest_${questId}`;
  const existed = localStorage.getItem(questKey) !== null;

  if (existed) {
    localStorage.removeItem(questKey);
    console.log(`Reset quest: ${questId}`);
  }

  return existed;
};